module.exports = __webpack_public_path__ + "img/c-1.43acddb7.jpg";